import { MONITORING_CADENCES, type MonitoringCadence } from "./monitoring.js";

/** Actions available from the Products mapping-monitoring drawer. */
export const PRODUCT_MONITORING_ACTIONS = {
  ENABLE: "ENABLE",
  DISABLE: "DISABLE",
} as const;

export type ProductMonitoringAction =
  (typeof PRODUCT_MONITORING_ACTIONS)[keyof typeof PRODUCT_MONITORING_ACTIONS];

/** Per-target result codes that remain safe to present in a merchant batch result. */
export const PRODUCT_MONITORING_OUTCOMES = {
  UPDATED: "UPDATED",
  UNCHANGED: "UNCHANGED",
  NO_MAPPINGS: "NO_MAPPINGS",
  PRODUCT_NOT_FOUND: "PRODUCT_NOT_FOUND",
  BATCH_STOPPED: "BATCH_STOPPED",
  UNCONFIRMED: "PRODUCT_MONITORING_UNCONFIRMED",
} as const;

/** Merchant-visible audit actions for actual monitoring schedule transitions. */
export const PRODUCT_MONITORING_AUDIT_ACTIONS = {
  ENABLED: "PRODUCT_MONITORING_ENABLED",
  PAUSED: "PRODUCT_MONITORING_PAUSED",
} as const;

/** The bounded worker job created for one due product mapping. */
export const MAPPING_CHECK_JOB_TYPE = "MAPPING_CHECK" as const;

/** Durable queue delivery state for a mapping-check job's exact payload. */
export const MAPPING_CHECK_DISPATCH_STATES = {
  PENDING: "PENDING",
  CONFIRMED: "CONFIRMED",
} as const;

export type MappingCheckDispatchState =
  (typeof MAPPING_CHECK_DISPATCH_STATES)[keyof typeof MAPPING_CHECK_DISPATCH_STATES];

/** The current configured product-mapping monitoring limit. */
export const PRODUCT_MONITORING_MAX_MAPPINGS = 100;

/** Cadences permitted by the current monitoring configuration. */
export const PRODUCT_MONITORING_ALLOWED_CADENCES: readonly MonitoringCadence[] =
  MONITORING_CADENCES;
